import dayjs from 'dayjs';
import API from '../../api';

// Servizio condiviso per la creazione della tessera GD figlia GRATUITA, collegata a una tessera PD.
// De-duplica la stessa logica finora ripetuta in RegistrationPage (createGdChildCard),
// ProfilePage e cardsTab (createFreeLinkedGdCard). È DISACCOPPIATO dall'UI: non mostra popup e non
// ricarica liste — restituisce un esito e lascia al chiamante la gestione dell'interfaccia.

/**
 * Crea una tessera GD figlia gratuita collegata a una PD (parent_id).
 * L'importo 0 è forzato lato server per la presenza del parent_id; le tariffe GD sono best-effort
 * (se l'endpoint fallisce si procede comunque, la figlia è gratuita).
 *
 * @param {object} params
 * @param {string} params.userId
 * @param {string} params.parentCardId - id della tessera PD padre
 * @param {string} params.gdEntityId - entità master GD (payment_entity_id)
 * @param {*} params.birthDate - data di nascita (qualsiasi valore accettato da dayjs)
 * @param {boolean|number} params.digitalFormat - formato tessera (online/cartacea)
 * @returns {Promise<{ok: true} | {ok: false, reason: 'no-campaign'}>}
 * @throws in caso di errore di rete sulla POST /memcards (gestito dal chiamante)
 */
export async function createFreeLinkedGdCard({ userId, parentCardId, gdEntityId, birthDate, digitalFormat }) {
  const [campRes, statusRes] = await Promise.all([
    API.get('/active_campaign?campaign_type=GD'),
    API.get('/paystatus'),
  ]);

  const campaignId = campRes.data?.id;
  if (!campaignId) {
    return { ok: false, reason: 'no-campaign' };
  }

  const waitingStatusId = (statusRes.data || []).find((status) => status.type === 'W')?.id;

  const birth = dayjs(birthDate).format('YYYY/MM/DD');
  let gdRates = [];
  try {
    const ratesRes = await API.get(
      `/active_rates/?position_id=&entity_id=${gdEntityId}&campaign_type=GD&user_birth_date=${birth}`
    );
    gdRates = (ratesRes.data.entity_rate || []).map((offer) => ({ id: offer.rate.id, price: 0 }));
  } catch (e) {
    gdRates = [];
  }

  await API.post('/memcards', {
    user_id: userId,
    campaign_id: campaignId,
    parent_id: parentCardId,
    rates: gdRates,
    payment_entity_id: gdEntityId,
    payment_online: 1,
    digital_format: Number(digitalFormat),
    payment_status: waitingStatusId,
  });

  return { ok: true };
}
